import { request } from './axios.js'

// let brend_ = '/hqCar/'
let brend_ = '/icaur/'
export let modelDetailsApi = (data) => request({ data, url: `/webapp/api${brend_}modelDetails` })
export let modelParameterApi = (data) => request({ data, url: `/webapp/api${brend_}modelParameter` })
export let modelListApi = (data) => request({ data, url: `/webapp/api${brend_}modelList` })
export let addIcaurCusApi = (data) => request({ data, url: `/webapp/api/icaurCus/add` })
export let modelPropParameterApi = (data) => request({ data, url: `/webapp/api${brend_}modelPropParameter` })

export let newsListApi = (data) => request({ data, url: `/webapp/api${brend_}newsList` })
export let newsDetailsApi = (data) => request({ data, url: `/webapp/api${brend_}newsDetails` })
export let newsCreateApi = (data) => request({ data, url: `/webapp/api${brend_}newsCreate` })
export let newsEditApi = (data) => request({ data, url: `/webapp/api${brend_}newsEdit` })
export let newsDeleteApi = (data) => request({ data, url: `/webapp/api${brend_}newsDelete` })

export let payStripeCusApi = (data) =>
  request({ data, url: `/webapp/api/pay/stripe` })
export let icaurCusUserInfoApi = (data) =>
  request({ data, url: `/webapp/api${brend_}userInfo'` })

// KOC 招募活動
export let imgUploadsApi = (data) =>
  request({ data, url: '/webapp/api/imgUploads', method: 'post', headers: { 'Content-Type': 'multipart/form-data' } })
export let icaurKocAddApi = (data) =>
  request({ data, url: '/webapp/api/icaur/kocAdd' })
